import React from 'react';
import { Button } from '@mantine/core';
import { IconChevronDown, IconChevronRight } from '@tabler/icons-react';
import { ganttToolbarButtonProps } from './ganttToolbarStyles';

export interface GanttExpandCollapseButtonProps {
  expandedAll: boolean;
  onToggle: (expanded: boolean) => void;
}

/** Location-management style Expand all / Collapse all control. */
export function GanttExpandCollapseButton({
  expandedAll,
  onToggle,
}: GanttExpandCollapseButtonProps) {
  return (
    <Button
      {...ganttToolbarButtonProps}
      variant="default"
      type="button"
      onClick={() => onToggle(!expandedAll)}
      rightSection={
        expandedAll ? (
          <IconChevronRight size={14} stroke={1.75} />
        ) : (
          <IconChevronDown size={14} stroke={1.75} />
        )
      }
      aria-label={expandedAll ? 'Collapse all' : 'Expand all'}
    >
      {expandedAll ? 'Collapse all' : 'Expand all'}
    </Button>
  );
}
